app.newCustomer = () => {
  function init() {
    let check = document.querySelector('#customer_form_shipping_is_billing')
    check.addEventListener('change', toggledUseBilling)
  }

  let toggledUseBilling = event => {
    shippingFields().forEach(field => {
      if(event.target.checked) {
        field.value = null;
        field.removeAttribute('required');
        field.setAttribute('disabled', true);
      } else {
        field.setAttribute('required', true);
        field.removeAttribute('disabled');
      }
    })
  }

  let shippingFields = () => {
    let selectors = [
      '#customer_form_shipping_address1',
      '#customer_form_shipping_address2',
      '#customer_form_shipping_city',
      '#customer_form_shipping_state',
      '#customer_form_shipping_zip',
    ]
    return document.querySelectorAll(selectors.join(', '));
  }

  return init();
}
